/**
 * @generated SignedSource<<d03436fece5a29ff324b48d046351c26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRedemptionOptionItemQuery_optionRef$data = {
  readonly imageUrl: string | null;
  readonly key: string;
  readonly name: string;
  readonly " $fragmentType": "useRedemptionOptionItemQuery_optionRef";
};
export type useRedemptionOptionItemQuery_optionRef$key = {
  readonly " $data"?: useRedemptionOptionItemQuery_optionRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRedemptionOptionItemQuery_optionRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRedemptionOptionItemQuery_optionRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "RedemptionOptionData",
  "abstractKey": null
};

(node as any).hash = "d6ca781b3a2a1c8465e1cf0d5fee50fa";

export default node;
